import { render, staticRenderFns } from "./HousingModalQuotasMassive.vue?vue&type=template&id=43c9f440&scoped=true&"
import script from "./HousingModalQuotasMassive.vue?vue&type=script&lang=js&"
export * from "./HousingModalQuotasMassive.vue?vue&type=script&lang=js&"
import style0 from "./HousingModalQuotasMassive.vue?vue&type=style&index=0&id=43c9f440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c9f440",
  null
  
)

export default component.exports